import { useCallback, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";
import { MAX_RETRIES } from "../../configs/configs";

function useGetMerchantExtraCharges() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [extraCharges, setExtraCharges] = useState({});
  const { retryCount, setRetryCount } = useRetry(
    () => getMerchantExtraCharges(),
    MAX_RETRIES
  );

  const getMerchantExtraCharges = useCallback(() => {
    fetchWrapper({
      endpoint_url: "merchant/getMerchantExtraCharges",
      set_content_type_header: false,
      method: "GET",
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setExtraCharges(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "fetch",
            message: "Get Merchant Extra Charges",
            extra: "Retrying...",
          });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "response",
            message: "Get Merchant Extra Charges",
            extra: "Retrying...",
          });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    getMerchantExtraCharges();
  }, []);

  return { getMerchantExtraCharges, extraCharges };
}

export default useGetMerchantExtraCharges;
